import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  documentsHeaders: {
    height: 35,
    borderBottom: '1px solid #8F92A1',
    display: 'flex',
    paddingLeft: 23,
    paddingRight: 80,
    alignItems: 'stretch',
    flexFlow: 'row wrap',
    justifyContent: 'space-between'
  },
  documentName: {
    flexGrow: 1,
    width: 179,
    color: theme.palette.text.secondary
  },
  documentLink: {
    flexGrow: 0,
    color: theme.palette.text.secondary
  },
  actionName:{
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary
  },
  actionDate: {
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary
  },
  lawShortName: {
    flexGrow: 1,
    width: 179,
    color: theme.palette.text.secondary
  },
  lawCountry: {
    flexGrow: 0,
    width: 179,
    color: theme.palette.text.secondary
  },
  lawArticles: {
    flexGrow: 1,
    width: 179,
    color: theme.palette.text.secondary
  },
  lawLink: {
    flexGrow: 0,
    color: theme.palette.text.secondary
  },
  appBar: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.text.secondary}`,
    borderTop: `1px solid ${theme.palette.text.secondary}`,
    marginLeft: '-24px',
    width: 'calc(100% + 48px)',
    '& .MuiTabs-root': {
      marginBottom: '-1px'
    },
    '& .MuiTab-wrapper': {
      fontWeight: 600
    }
  },
  modalContent: {
    paddingTop: 0,
    '& .MuiDialogActions-root': {
      marginTop: 30
    }
  },
  generalInfoHeader: {
    marginBottom: 40,
    marginTop: 49,
    fontSize: '22px'
  },
  domainsGrid: {
    paddingRight: '20px'
  },
  roomsGrid: {
    paddingLeft: '20px'
  },
  adviceSubHeader: {
    fontWeight: 600,
    fontSize: '22px',
    letterSpacing: '-0.4px',
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 60,
    marginBottom: 30
  },
  headerText: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginRight: 20
    }
  },
  lawsHeader: {
    width: 300
  },
  lawsInput: {
    '& .MuiInputLabel-formControl': {
      top: '-8px'
    },
    '&.Mui-focused  .MuiInputLabel-formControl': {
      fontSize: '0.7rem'
    },
    '& .MuiInputBase-root': {
      borderRadius: '10px',
      borderWidth: '1px',
      marginTop: 0,
      marginBottom: 0,
      paddingTop: 1,
      paddingBottom: 1
    }
  },
  errorMessage: {
    color: 'red'
  },
  actionDescription:{
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary
  },
  actionWho:{
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary
  },
  actionDeadline: {
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary
  },
  actionRepeat: {
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary
  },
  addNewSetContainer: {
    borderTop: '1px solid #000',
    paddingTop: 20
  }
}))

export default useStyles
